import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import mediaStyles from "src/features/Common/Common.module.scss";

type ICheckSvg = {
    color: string;
    className?: string;
};
export const CheckPatternSvg = ({ color, className }: ICheckSvg) => {
    const desktopPatternSvg = (
        <svg
            className={classNames(className, mediaStyles.hideOnMobile)}
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle opacity="0.2" cx="28" cy="28" r="28" fill={color} />
            <path
                d="M21.0001 37.7996L12.8334 29.6329C11.9234 28.7229 10.4768 28.7229 9.56678 29.6329C8.65678 30.5429 8.65678 31.9896 9.56678 32.8996L19.3434 42.6763C20.2534 43.5863 21.7234 43.5863 22.6334 42.6763L47.3668 17.9663C48.2768 17.0563 48.2768 15.6096 47.3668 14.6996C46.4568 13.7896 45.0101 13.7896 44.1001 14.6996L21.0001 37.7996Z"
                fill={color}
            />
        </svg>
    );
    const mobilePatternSvg = (
        <svg
            className={classNames(className, mediaStyles.hideOnDesktop)}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle opacity="0.2" cx="12" cy="12" r="12" fill={color} />
            <path
                d="M9 16.1998L5.5 12.6998C5.11 12.3098 4.48999 12.3098 4.1 12.6998C3.71 13.0898 3.71 13.7098 4.1 14.0998L8.29 18.2898C8.68 18.6798 9.30999 18.6798 9.7 18.2898L20.3 7.69982C20.69 7.30982 20.69 6.68982 20.3 6.29982C19.91 5.90982 19.29 5.90982 18.9 6.29982L9 16.1998Z"
                fill={color}
            />
        </svg>
    );
    return (
        <>
            {desktopPatternSvg}
            {mobilePatternSvg}
        </>
    );
};

CheckPatternSvg.defaultProps = {
    className: "",
};
